// src/components/layout/SearchBar.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function SearchBar() {

    const navigate = useNavigate();

    const [keyword, setKeyword] = useState("");

    //--------------------------------------------------------
const { t } = useTranslation();
    const handleSubmit = (e) => {

        e.preventDefault();

        const value = keyword.trim();

        if (!value) {

            navigate("/searchconsultant");

            return;

        }

        navigate(

            `/searchconsultant?keyword=${encodeURIComponent(value)}`

        );

    };

    //--------------------------------------------------------

    const clearSearch = () => {

        setKeyword("");

        navigate("/searchconsultant");

    };

    //--------------------------------------------------------

    return (

        <form

            className="searchbar"

            onSubmit={handleSubmit}

        >

            <div className="searchbar-wrapper">

                <FaSearch className="searchbar-icon" />

                <input

                    type="text"
                    className="searchbar-input"
                    placeholder={t("consultant.search.placeholder")}
                    value={keyword}

                    onChange={(e) =>

                        setKeyword(e.target.value)

                    }

                />

                {

                    keyword &&

                    <button

                        type="button"

                        className="searchbar-clear"

                        onClick={clearSearch}

                    >

                        <FaTimes />

                    </button>

                }

                <button

                    type="submit"

                    className="searchbar-button"

                >

                    {t("button.search")}

                </button>

            </div>

        </form>

    );

}